export default __webpack_public_path__ + "static/media/user-icon.2c37aa89.png";